import Enumerator from './Enumerator';

export const frequencyOptions = ['none', 'all_the_time', 'sometimes', 'rarely'];

export class FrequencyOption extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'all_the_time';
        break;
      case '2':
        correctOption = 'sometimes';
        break;
      case '3':
        correctOption = 'rarely';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

FrequencyOption.initEnum(frequencyOptions);

export default {
  frequencyOptions,
  FrequencyOption
};
